import React, { Component } from 'react';

import ScheduledEvents from './ScheduledEvents';
import ModalWrapper from './ModalWrapper';
import sortAlphabetically from '../../utils/sortAlphabetically';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default class DisplayRowSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.displayValue}
        </td>
        <ModalWrapper
          show={this.props.edit}
          title={this.props.prettyName}
          handleClose={this.props.handleClose}
          handleSave={this.props.handleSave}
          handleSchedule={this.props.handleSchedule}
        >
          <div>
            <select
              name={this.props.id}
              value={this.props.value}
              onChange={this.props.handleChange}
              className="form-control"
              required
            >
              <option value="">{this.props.default}</option>
              {sortAlphabetically(Object.keys(this.props.options)).map(
                (option) => (
                  <option key={option} value={option}>
                    {this.props.options[option]}
                  </option>
                ),
              )}
            </select>
            <font className="mandatory">{this.props.errorString}</font>
          </div>
          <ScheduledEvents
            events={this.props.events}
            id={this.props.id}
            deleteScheduleAction={this.props.deleteScheduleAction}
          />
        </ModalWrapper>
      </tr>
    );
  }
}
